import React from 'react';
import { updateSpace } from '../../app-main/actions/space';
import { SubmissionError } from 'redux-form';
import { find } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitCancellationPolicy = (values = {}, dispatch, props) => {
  const { cancellation_policy: selectedPolicy } = values;
  const {
    cancellationPolicy = [],
    spaceId,
    accessToken,
    isEdit
  } = props;
  const payload = { cancellation_policy: find(cancellationPolicy, { id: selectedPolicy }) };

  return dispatch(updateSpace(spaceId, accessToken, payload))
    .then(() => {
      // NOTE: add analytics here
      if (isEdit) {
        window.location.href = `/your-space/${spaceId}`;
        return null;
      }

      window.location.href = `/your-space/${spaceId}/activate-listings`;
    })
    .catch(() => {
      throw new SubmissionError({ _error: <FormattedMessage id="hosting.on_submit_cancellation_policy.error_message" defaultMessage="Submission failed. Please refresh and try again." /> });
    });
};

export default onSubmitCancellationPolicy;
